<div class="promotion-container">
  <div class="promotion-holder">
    <div>
      <img
        class="promotion-image"
        src="assets/register/promotionBackground.svg"
      />
      <div class="promotion-lock-top-holder">
        <div class="promotion-lock-top-holder-relative">
          <div class="promotion-lock-top-container">
            <img
              class="promotion-time-image"
              src="assets/register/timeIcon.svg"
            />
            <div class="promotion-lock-top-left">
              <div class="promotion-lock-image-title">
                تخفیف ویژه کاربران جدید
              </div>
              <div class="promotion-lock-image-description">
                فرصت محدود برای خرید اشتراک بنتو
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="promotion-lock-image-shop" (click)="goToShop()">
        اشتراک بخرید
      </div>
      <div class="promotion-back" (click)="back()">
        <img
          src="assets/general/cross-white.svg"
          style="width: 24px; height: 24px"
        />
      </div>
    </div>
    <div>
      <div class="promotion-lock-top-title">برای یک تغییر بزرگ آماده باشید</div>
      <div class="promotion-lock-line"></div>
      <div>
        <div class="promotion-lock-checkmark-holder">
          <img src="assets/general/tick-white.png" />
        </div>
        <div class="promotion-lock-top-description">
          در کمتر از ۱ دقیقه، برنامه غذایی متناسب با سلیقه و شرایط خاص خود
          دریافت کنید.
        </div>
      </div>
      <div>
        <div class="promotion-lock-checkmark-holder">
          <img src="assets/general/tick-white.png" />
        </div>
        <div class="promotion-lock-top-description">
          با امکان دریافت مجدد برنامه غذایی، نگران نرسیدن به هدف خود نباشید.
        </div>
      </div>
      <div>
        <div class="promotion-lock-checkmark-holder">
          <img src="assets/general/tick-white.png" />
        </div>
        <div class="promotion-lock-top-description">
          با کمک دستور پخت‌های متنوع و نمودارهای عملکرد، از رسیدن به سلامتی
          مطمئن شوید.
        </div>
      </div>
      <div class="promotion-lock-mid-title">کاربران خوشحال</div>
      <div class="promotion-lock-line"></div>
      <div
        class="promotion-lock-mid-scroll"
        (swiperight)="swipe($event.type)"
        (swipeleft)="swipe($event.type)"
      >
        <div class="promotion-lock-mid-card" style="right: 24px" id="0card">
          <div class="promotion-lock-mid-card-title">زیور</div>
          <div class="promotion-lock-mid-card-rating">⭐ ⭐ ⭐ ⭐ ⭐</div>
          <div class="promotion-lock-mid-card-comment">
            سلام خیلی عالیه این برنامه. تو این وقت کم چند کیلو کم کردم. در صورتی
            که غذای دلخواه خودم رو هم خوردم.
          </div>
        </div>
        <div
          class="promotion-lock-mid-card"
          style="right: calc(100% + 24px)"
          id="1card"
        >
          <div class="promotion-lock-mid-card-title">توران</div>
          <div class="promotion-lock-mid-card-rating">⭐ ⭐ ⭐ ⭐ ⭐</div>
          <div class="promotion-lock-mid-card-comment">
            من خیلی از برنامه راضیم. همون مقدار کالری رو که برام تعیین کردین
            استفاده میکنم. در عین وزن کم کردن، یاد گرفتیم مواد سالم رو جایگزین
            غذاهای مضر بکنیم.
          </div>
        </div>
        <div
          class="promotion-lock-mid-card"
          style="right: calc(200% + 24px)"
          id="2card"
        >
          <div class="promotion-lock-mid-card-title">امیررضا</div>
          <div class="promotion-lock-mid-card-rating">⭐ ⭐ ⭐ ⭐ ⭐</div>
          <div class="promotion-lock-mid-card-comment">
            دوستان عزیز این بهترین برنامه لاغری است. توصیه میکنم استفاده کنید.
            پشیمان نمی‌شوید. با تشکر از سازندگان و مشاوران برنامه.
          </div>
        </div>
        <div
          class="promotion-lock-mid-card"
          style="right: calc(300% + 24px)"
          id="3card"
        >
          <div class="promotion-lock-mid-card-title">مهدی</div>
          <div class="promotion-lock-mid-card-rating">⭐ ⭐ ⭐ ⭐ ⭐</div>
          <div class="promotion-lock-mid-card-comment">
            سلام. من برنامه جدید بنتو رو ریختم. فوق‌العاده است. آفرین به بچه‌های
            خلاق ایرانی که این برنامه را به وجود آوردند. دست مریزاد.
          </div>
        </div>
        <div
          class="promotion-lock-mid-card"
          style="right: calc(400% + 24px)"
          id="4card"
        >
          <div class="promotion-lock-mid-card-title">نازنین</div>
          <div class="promotion-lock-mid-card-rating">⭐ ⭐ ⭐ ⭐ ⭐</div>
          <div class="promotion-lock-mid-card-comment">
            بینهایت عالیه. خیلی خوب دارم وزن کم میکنم و اصلا گرسنه نمیشم.
            برنامتون بینظیره و همتا نداره. امیدوارم روزبه‌روز پیشرفت کنید. خدا
            قوت.
          </div>
        </div>
      </div>
      <div class="promotion-lock-mid-indicators">
        <div
          [ngClass]="
            currentHappyUser === 0
              ? 'promotion-lock-mid-selected-indicator'
              : 'promotion-lock-mid-indicator'
          "
        ></div>
        <div
          [ngClass]="
            currentHappyUser === 1
              ? 'promotion-lock-mid-selected-indicator'
              : 'promotion-lock-mid-indicator'
          "
        ></div>
        <div
          [ngClass]="
            currentHappyUser === 2
              ? 'promotion-lock-mid-selected-indicator'
              : 'promotion-lock-mid-indicator'
          "
        ></div>
        <div
          [ngClass]="
            currentHappyUser === 3
              ? 'promotion-lock-mid-selected-indicator'
              : 'promotion-lock-mid-indicator'
          "
        ></div>
        <div
          [ngClass]="
            currentHappyUser === 4
              ? 'promotion-lock-mid-selected-indicator'
              : 'promotion-lock-mid-indicator'
          "
        ></div>
      </div>
      <div class="promotion-lock-bot-title">
        با خرید اشتراک زودتر به هدف خود برسید
      </div>
      <div class="promotion-lock-line"></div>
      <div class="promotion-lock-table-title-first">پایه</div>
      <div class="promotion-lock-table-title-second">ویژه</div>
      <div
        class="promotion-lock-table-cell"
        style="background: rgb(249, 249, 249)"
      >
        <div class="promotion-lock-table-cell-title">
          امکان ثبت و دنبال کردن تغییرات وزن و آب
        </div>
        <img
          class="promotion-lock-table-cell-first-image"
          src="assets/general/tick-blue.svg"
        />
        <img
          class="promotion-lock-table-cell-second-image"
          src="assets/general/tick-blue.svg"
        />
      </div>
      <div class="promotion-lock-table-cell">
        <div class="promotion-lock-table-cell-title">
          عضویت در شبکه اجتماعی تریبون
        </div>
        <img
          class="promotion-lock-table-cell-first-image"
          src="assets/general/tick-blue.svg"
        />
        <img
          class="promotion-lock-table-cell-second-image"
          src="assets/general/tick-blue.svg"
        />
      </div>
      <div
        class="promotion-lock-table-cell"
        style="background: rgb(249, 249, 249)"
      >
        <div class="promotion-lock-table-cell-title">
          دریافت برنامه غذایی اختصاصی
        </div>
        <img
          class="promotion-lock-table-cell-first-image"
          src="assets/plan/lock-gray.svg"
        />
        <img
          class="promotion-lock-table-cell-second-image"
          src="assets/general/tick-blue.svg"
        />
      </div>
      <div class="promotion-lock-table-cell">
        <div class="promotion-lock-table-cell-title">
          امکان افزودن و ویرایش غذا
        </div>
        <img
          class="promotion-lock-table-cell-first-image"
          src="assets/plan/lock-gray.svg"
        />
        <img
          class="promotion-lock-table-cell-second-image"
          src="assets/general/tick-blue.svg"
        />
      </div>
      <div
        class="promotion-lock-table-cell"
        style="background: rgb(249, 249, 249)"
      >
        <div class="promotion-lock-table-cell-title">
          دسترسی نامحدود به دستور پخت‌های سالم
        </div>
        <img
          class="promotion-lock-table-cell-first-image"
          src="assets/plan/lock-gray.svg"
        />
        <img
          class="promotion-lock-table-cell-second-image"
          src="assets/general/tick-blue.svg"
        />
      </div>
      <div class="promotion-lock-bot-shop" (click)="goToShop()">
        اشتراک بخرید
      </div>
    </div>
  </div>
</div>
